import React from 'react';

const PaginatorStateContext = React.createContext();

export default PaginatorStateContext;
